import axios from "axios";

export default function useAxios() {
    // For onboarding, we might need to get token from URL params or localStorage
    // For now, we'll make it work without auth token, or you can pass it as needed
    
    async function get(url: string, config?: any) {
        let cfg: any = config ? config : {}
        // Add token if available from URL params or localStorage
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token') || localStorage.getItem('onboarding-token');
        if (token) {
            cfg.headers = {
                ...cfg.headers,
                Authorization: `Bearer ${token}`
            }
        }
        const response = await axios.get(url, cfg);
        return response
    }

    async function post(url: string, data: any, config?: any) {
        let cfg: any = config ? config : {}
        // Add token if available from URL params or localStorage
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token') || localStorage.getItem('onboarding-token');
        if (token) {
            cfg.headers = {
                ...cfg.headers,
                Authorization: `Bearer ${token}`
            }
        }
        let response = await axios.post(url, data, cfg);
        return response
    }

    return { get, post };
}

